import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql } from './DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql';

export const DatasourcesDisplayGridRowDataFragmentGql: DocumentNode = gql`
fragment DatasourcesDisplayGridRowDataFragment on PublishedDatasource {
  ...DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpace
  containerName
  containerType
}
${DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql}
`;
